import { createUseStyles, ComposedTheme } from '@glu/theming';

const styles = ({
  dataComponents: {
    drawer: { footer },
  },
}: ComposedTheme) => ({
  applyButtonWrapper: {
    alignItems: 'center',
    background: footer.backgroundColor,
    boxShadow: '0px -1px 15px rgba(0,0,0,0.2)',
    display: 'flex',
    padding: [16, 20],
    width: '100%',
  },
  cancelButton: {
    color: footer.cancelButton.color,
    marginLeft: 20,
  },
});

export default createUseStyles(styles);
